<form [formGroup]="form">
  <div class="row">
    <div class="col-3 px-0">
      <rask-checkbox
        formControlName="selected"
        [raskDisabledControl]="readonly"
        (change)="selectedChanged($event)"
        class="mt-0"
        raskVirkeskopRule [messageId]="['certifikatselected'+groupName]" [entityGuid]="kontraktGuid"
        [label]="label"
        [text]="groupName">
      </rask-checkbox>
    </div>
    <div class="col-2 mt-4 pt-2 px-0">
      @if (!kontrakt.isSkogsvardFPVKontrakt && groupName !== CertifikatTyper.Ocertifierat) {
        <a
          href="{{getLink()}}" target="_blank">
          Kontroll (ny flik)
          <i class="fa-regular fa-up-right-from-square"></i>
        </a>
      }
    </div>
    <div class="col-4 px-0">
      @if (!kontrakt.isSkogsvardFPVKontrakt && groupName !== CertifikatTyper.Ocertifierat) {
        <rask-selector
          [style.display]="certifikat.state !== 'INITIAL' ? '' : 'none'"
          [canDelete]="true"
          formControlName="certifikatId"
          [raskDisabledControl]="readonly"
          raskVirkeskopRule [messageId]="['certifikat'+groupName]" [entityGuid]="kontraktGuid"
          (change)="numberChanged($event)"
          label="Nummer & namn"
          [values]="certifikatList"
          bindLabel="key"
          bindValue="value"
          class="mt-0">
        </rask-selector>
      }
    </div>
    <div class="col-3 px-0">
      @if (!kontrakt.isSkogsvardFPVKontrakt && groupName !== CertifikatTyper.Ocertifierat) {
        <rask-datepicker
          [style.display]="certifikat.state === 'CERTIFIKAT_SELECTED' ? '' : 'none'"
          [maxDate]="today"
          [allowInvalidInput]="true"
          formControlName="kontrolldatum"
          [raskDisabledControl]="readonly"
          raskVirkeskopRule [messageId]="['certifikatdatum'+groupName]" [entityGuid]="kontraktGuid"
          label="Datum för gilt. kontroll"
          class="mt-0">
        </rask-datepicker>
      }
    </div>
  </div>
</form>